//Location Hubs

let hubs = document.getElementsByClassName('hub-location-link');
let hubClose = document.getElementsByClassName('hub-close');


if (window.screen.width < 768) {

    for (let i = 0; i < hubs.length; i++) {
        let details = document.getElementsByClassName('hub-location-details');

        hubs[i].addEventListener('click', function() {
             //close other open boxes
             let openBoxes = document.querySelectorAll('.hub-location-details.open');
             for (let i = 0; i < openBoxes.length; i++) {
               openBoxes[i].classList.remove('open');
             }

            details[i].classList.add('open');
        })
        hubClose[i].addEventListener('click', function() {
            details[i].classList.remove('open');
        })
    }

}
